import { createApp } from 'vue'
import { createPinia } from 'pinia'
import VueGtag from 'vue-gtag'

/**
 * Element Plus
 * Import element-plus/index.scss before scss of element-plus
 * to avoid the problem of sass mixed variables
 */
// Comment this line because import already handled by preprocessorOptions in vite.config.ts
// import "./styles/element-plus/index.scss";
// import 'element-plus/dist/index.css'
import 'element-plus/es/components/message/style/css'
import 'element-plus/es/components/loading/style/css'

// Tailwind
import './styles/tailwind/index.css'
import './styles/main.scss'

import App from './App.vue'
import router from './router'
import { initSentry, attachSentryToPinia } from '@/utils/services/sentryService'

const app = createApp(App)

// `initSentry` and `attachSentryToPinia` are no-ops in non-production
// builds and when `VITE_SENTRY_DSN` is empty. See sentryService.ts for the
// production-gating design and privacy posture.
initSentry(app, router)

const pinia = createPinia()
attachSentryToPinia(pinia)
app.use(pinia)
app.use(router)

// Only activate Google Analytics if VITE_GA_MEASUREMENT_ID is provided
if (import.meta.env.VITE_GA_MEASUREMENT_ID) {
  app.use(
    VueGtag,
    {
      config: { id: import.meta.env.VITE_GA_MEASUREMENT_ID }
    },
    router
  )
}

// Make emergency debug reset available globally for console access
if (typeof window !== 'undefined') {
  ;(window as any).resetDebugStates = () => {
    // Emergency debug reset functionality available in console
    // Debug states are now memory-only and will reset on page refresh
  }
}

app.mount('#app')
